import { render, staticRenderFns } from "./SurveyDialog.vue?vue&type=template&id=0b8fb2ea"
import script from "./SurveyDialog.vue?vue&type=script&lang=js"
export * from "./SurveyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports